export const normalizeGenreKey = (value: string) => value.trim().toLowerCase();

export const toSlugCandidate = (value: string) => value.trim().toLowerCase().replace(/\s+/g, '-');

/** Maps both genre slugs and names (lowercased) to their canonical slug. */
export const buildGenreSlugMap = (rows: Array<{ name?: string; slug?: string }>) => {
  const map = new Map<string, string>();
  rows.forEach((genre) => {
    const slug = typeof genre.slug === 'string' ? genre.slug.trim().toLowerCase() : '';
    const name = typeof genre.name === 'string' ? genre.name.trim().toLowerCase() : '';
    if (!slug) return;
    map.set(slug, slug);
    if (name) map.set(name, slug);
  });
  return map;
};

/** Maps both genre slugs and names (lowercased) to the canonical display name. */
export const buildGenreDisplayMap = (rows: Array<{ name?: string; slug?: string }>) => {
  const map = new Map<string, string>();
  rows.forEach((genre) => {
    const slug = typeof genre.slug === 'string' ? genre.slug.trim().toLowerCase() : '';
    const name = typeof genre.name === 'string' ? genre.name.trim() : '';
    if (!name) return;
    if (slug) map.set(slug, name);
    map.set(normalizeGenreKey(name), name);
  });
  return map;
};

/** Maps both genre slugs and names (lowercased) to their numeric ID. */
export const buildGenreIdMap = (rows: Array<{ id?: number; name?: string; slug?: string }>) => {
  const map = new Map<string, number>();
  rows.forEach((genre) => {
    if (typeof genre.id !== 'number') return;
    const slug = typeof genre.slug === 'string' ? genre.slug.trim().toLowerCase() : '';
    const name = typeof genre.name === 'string' ? genre.name.trim().toLowerCase() : '';
    if (slug) map.set(slug, genre.id);
    if (name) map.set(name, genre.id);
  });
  return map;
};

/** Maps genre ID to its canonical display name. */
export const buildGenreNameMapById = (rows: Array<{ id?: number; name?: string }>) => {
  const map = new Map<number, string>();
  rows.forEach((genre) => {
    if (typeof genre.id !== 'number') return;
    const name = typeof genre.name === 'string' ? genre.name.trim() : '';
    if (name) map.set(genre.id, name);
  });
  return map;
};
